import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c88e1df4"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=c88e1df4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.25_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_w4ow4wqgwsbk3quj5bombr2dpu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports